import { CustomerPortalHeader } from 'components/Header/CustomerPortalHeader';
import {
  CleanFiltersButton,
  Content,
  ContentHeader,
  FiltersButton,
  OpenCallButton,
  Page,
  RadioFormGroup,
  SearchAndFilterContainer,
  StyledContainerHeader,
  StyledContainerSearchBar,
  StyledFormGroup,
  StyledFormRadio,
  StyledInnerGridColumn,
  TablecontainerWrapper,
  TableTitle,
  StyledContainerFooter,
  LeftContainerFooter,
  RightContainerFooter,
  Paginate,
  StyledDateRangePicker,
  MobileCleanFilterDiv,
  FooterContainer,
  NoOcurrenceScreen,
  ReloadButton,
  StyledInnerGridRow,
  AtentionModal,
  FadingWrapper,
  RightFade,
  ScrollArea,
} from './styled';

import { URLS } from 'constants/urls';
import { Button } from 'components/Button';
import { ReactComponent as WarningIcon } from 'assets/icons/warning-yellow-hexa-icon.svg';
import { ReactComponent as PlusIcon } from 'assets/icons/plus-icon.svg';
import { FieldRow } from 'components/Form/subcomponents/FieldRow';
import { Controller, useForm, useWatch } from 'react-hook-form';
import { ReactComponent as FilterIcon } from 'assets/icons/filter.svg';
import { ReactComponent as CloseFilterIcon } from 'assets/icons/close-filter.svg';
import { ReactComponent as CleanFilterIcon } from 'assets/icons/cleanFiltersIcon.svg';
import { ReactComponent as LogoBlack } from 'assets/icons/logo-horizontal-black.svg';
import { ReactComponent as NotFoundIcon } from 'assets/icons/404-icon.svg';
import { ReactComponent as ReloadIcon } from 'assets/icons/loading-o-icon.svg';
import { Select } from 'components/Tables/ScheduleTable/Form/subcomponents/Select';
import { useState, useMemo, useEffect, useRef } from 'react';
import { Radio } from 'components/Form/subcomponents/Radio';
import CustomerPortalTable from 'components/Tables/CustomerPortalTable';
import { useMediaQuery } from 'react-responsive';
import { MobileCustomerPortalTable } from 'components/Tables/CustomerPortalTable/Mobile';
import { useCookies } from 'react-cookie';
import { ChamadoService } from 'services/main/endpoints/ChamadoService';
import { subMonths, format, addDays, parse } from 'date-fns';
import { createGenericErrorToast, createErrorToast } from 'utils/createToast';
import { Toast } from 'components';
import { DateRangePicker } from 'components/Form/subcomponents/MobileDateRangePicker';
import { FiltersService } from 'services/reports';
import { useDebounce } from 'hooks';
import { CustumerProfile } from 'components/CustomerProfile';
import { NovoChamado } from 'components/NovoChamado';

import * as Sentry from '@sentry/react';
export const CustomerPortal = () => {
  const [openNewChamadoModal, setOpenNewChamadoModal] = useState(false);

  const [isFirstMount, setIsFirstMount] = useState(true);
  const removeCookie = useCookies()[2];
  const cookie = useCookies()[0];
  const [openNewChamadoCookie, setOpenNewChamadoCookie] = useState(cookie?.openNewChamado?.openNewChamado);
  const [openMyProfile, setOpenMyProfile] = useState(false);
  const [loading, setLoading] = useState(false);
  const [occurrenceNumber, setOccurrenceNumber] = useState(0);
  const [toastList, setToastList] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [invalidUnit, setInvalidUnit] = useState(false);
  const debouncedSearchTerm = useDebounce(searchTerm, 300);
  const [pageNumber, setPageNumber] = useState(1);
  const [itensPerPage, setItensPerPage] = useState(5);
  const [areaPage, setAreaPage] = useState(1);
  const [areaSearch, setAreaSearch] = useState('');
  const [equipamentoPage, setEquipamentoPage] = useState(1);
  const [equipamentoSearch, setEquipamentoSearch] = useState('');
  const pageOptions = [
    { label: '5', value: 5 },
    { label: '10', value: 10 },
    { label: '25', value: 25 },
    { label: '50', value: 50 },
    { label: '100', value: 100 },
  ];
  const [filters, setFilters] = useState({
    unidade: [],
    status: [],
    ambiente: [],
    equipamento: [],
  });
  const initialPeriod = [subMonths(new Date(), 3), new Date()];
  const {
    watch,
    setValue,
    getValues,
    control,
    formState: { errors },
    register,
  } = useForm({
    defaultValues: {
      chamadosType: 'todos',
      unidade: cookie?.qrcodeFilters?.site ? cookie?.qrcodeFilters?.site?.value : '',
      status: '',
      ambiente: cookie?.qrcodeFilters?.site ? cookie?.qrcodeFilters?.ambiente?.value : '',
      equipamento: cookie?.qrcodeFilters?.equipamento ? cookie?.qrcodeFilters?.equipamento?.value : '',
      period: initialPeriod,
      pageItens: 5,
    },
    shouldUnregister: false,
  });
  const period = watch('period');
  const [filterIsOpen, setFilterIsOpen] = useState(cookie?.qrcodeFilters ? true : false);
  const statusOptions = [
    {
      label: 'Analisada',
      value: 1,
    },
    { label: 'Solucionada', value: 2 },
    { label: 'Não Analisada', value: 3 },
  ];
  const columns = useMemo(
    () => [
      { Header: 'Data/Hora de Abertura', accessor: 'data', width: 100 },
      { Header: 'Local / Equipamento', accessor: 'local', width: 300 },
      {
        Header: 'Nº Chamado / Descrição',
        accessor: 'chamado',
        width: 560,
      },
      { Header: 'Status', accessor: 'status', width: 240 },
    ],
    [],
  );
  const getDate = data => {
    const dateString = new Date(data);
    const date = dateString.toLocaleDateString();
    const time = dateString.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    return (
      <div>
        <div>{date}</div>
        <div>{time}</div>
      </div>
    );
  };
  const populateTableStrategy = async search => {
    const UnidadeId = getValues('unidade');
    const AreaId = getValues('ambiente');
    const EquipamentoId = getValues('equipamento');
    const StatusIds = getValues('status');
    const chamados = getValues('chamadosType') || 'meus';

    const result =
      typeof period === 'string'
        ? [
            period.split('/')[0],
            format(addDays(parse(period.split('/')[1], 'yyyy-MM-dd', new Date()), 1), 'yyyy-MM-dd'),
          ]
        : [format(initialPeriod[0], 'yyyy-MM-dd'), format(addDays(initialPeriod[1], 1), 'yyyy-MM-dd')];
    const baseParams = {
      dataInicio: result[0],
      dataFim: result[1],
      pageSize: itensPerPage || 5,
      pageIndex: pageNumber,
      empresa: cookie?.companies?.id,
      UnidadeId,
      AreaId,
      EquipamentoId,
      Search: search,
      StatusIds,
      SolicitanteId: chamados === 'meus' ? cookie.chamadosAccess.userId : '',
    };
    const [resp1, resp2, resp3] = await Promise.all([
      ChamadoService.getOccurences({ ...baseParams, StatusAprovacao: 1 }),
      ChamadoService.getOccurences({ ...baseParams }),
      ChamadoService.getOccurences({ ...baseParams, NaoAutorizadas: true }),
    ]);
    const mapData = data =>
      data?.map(item => ({
        data: getDate(item.dataRegistro),
        status: item?.tipoUltimaCorrecao,
        chamado: item?.descricao,
        local: getLocation(item?.areaNome, item?.equipamentoTag, item?.siteNome),
        text: item?.statusNome,
        anomaliaGid: item?.anomaliaGid,
        cqa: item?.cqa,
        isAguardandoAprovacao: item?.isAguardandoAprovacao,
        habilitarAutorizacao: item?.habilitarAutorizacao,
        statusAprovacao: item?.statusAprovacao,
        unidade: item?.siteId,
      }));
    return [mapData(resp1.data), mapData(resp2.data), mapData(resp3.data)];
  };
  const populateFilters = async () => {
    return await Promise.all([
      FiltersService.getUnits({ companyId: cookie?.companies?.id }),
      getValues('unidade') &&
        ChamadoService.getAreas({
          empresa: cookie?.companies?.id,
          siteId: getValues('unidade') || null,

          PageSize: 50,
          PageIndex: areaPage,
          Search: areaSearch,
        }),
      getValues('unidade') &&
        ChamadoService.getEquipments({
          empresa: cookie?.companies?.id,
          SiteId: getValues('unidade') || null,
          AreaId: getValues('ambiente') || null,

          PageIndex: equipamentoPage,
          PageSize: 50,
          Search: equipamentoSearch,
        }),
    ]).then(values => ({
      unidade: values[0]?.data?.map(({ nome, site }) => ({
        label: nome,
        value: site,
      })),
      ambiente: values[1]?.data?.map(({ nome, gid }) => ({
        label: nome,
        value: gid,
      })),
      equipamento: values[2]?.data?.map(({ gid, nome }) => ({
        label: nome,
        value: gid,
      })),
    }));
  };
  const getLocation = (areaNome, equipamentoNome, siteNome) => {
    return (
      <>
        {siteNome && (
          <div>
            <b>Unidade:</b> {siteNome}
          </div>
        )}

        {areaNome && (
          <div>
            <b>Área:</b> {areaNome}
          </div>
        )}

        {equipamentoNome && (
          <div>
            <b>Equipamento:</b> {equipamentoNome}
          </div>
        )}
      </>
    );
  };

  const populateFields = async search => {
    try {
      const tableData = await populateTableStrategy(search);
      tableData[1]?.plans?.reverse();
      const merged = [...(tableData[0] || []), ...(tableData[2] || [])];
      const uniqueMap = new Map();
      merged.forEach(item => {
        if (!uniqueMap.has(item.anomaliaGid)) {
          uniqueMap.set(item.anomaliaGid, item);
        }
      });

      const uniqueMerged = Array.from(uniqueMap.values());
      const arrayRemovidos = uniqueMerged.filter(
        item => item.habilitarAutorizacao === true || item.isAguardandoAprovacao === true,
      );
      setFields(tableData[1]);
      setPendingOcurrences(arrayRemovidos);
    } catch (err) {
      console.error(err);
      createGenericErrorToast(setToastList);
    }
  };
  const fetchFilters = async () => {
    try {
      const filters = await populateFilters();
      setFilters(filters);
    } catch (err) {
      console.error(err);
      createGenericErrorToast(setToastList);
    }
  };
  const fetchData = async search => {
    try {
      setLoading(true);
      await populateFields(search);
    } catch (err) {
      console.error(err);
      createGenericErrorToast(setToastList);
    } finally {
      setLoading(false);
    }
    if (!cookie?.companies?.id) {
      createErrorToast(setToastList, 'Selecione uma empresa antes de continuar');
      return;
    }
  };

  const fetchOccurNumber = async search => {
    try {
      const UnidadeId = getValues('unidade');
      const AreaId = getValues('ambiente');
      const EquipamentoId = getValues('equipamento');
      const StatusIds = getValues('status');
      const chamados = getValues('chamadosType') || 'meus';

      const date =
        typeof period === 'string'
          ? [
              period.split('/')[0],
              format(addDays(parse(period.split('/')[1], 'yyyy-MM-dd', new Date()), 1), 'yyyy-MM-dd'),
            ]
          : [format(initialPeriod[0], 'yyyy-MM-dd'), format(addDays(initialPeriod[1], 1), 'yyyy-MM-dd')];
      const result = await ChamadoService.getOcurrencesNumber({
        dataInicio: date[0],
        dataFim: date[1],
        empresa: cookie?.companies?.id,
        UnidadeId,
        AreaId,
        EquipamentoId,
        Search: search,
        StatusIds,
        SolicitanteId: chamados === 'meus' ? cookie.chamadosAccess.userId : '',
      });
      setOccurrenceNumber(result.data);
    } catch (err) {
      console.error(err);
      if (err.response?.status === 403) {
        setInvalidUnit(true);
      } else {
        createGenericErrorToast(setToastList);
      }
    }
  };
  const closeWarningModal = () => {
    setInvalidUnit(false);
    setOpenNewChamadoModal(false);
    cleanFilters();
    removeCookie('openNewChamado', { path: '/', domain: URLS.cookieDomain });
    setOpenNewChamadoCookie(false);
  };
  useEffect(() => {
    if (openNewChamadoCookie && cookie?.companies?.id) {
      setOpenNewChamadoModal(true);
    }
  }, [cookie?.companies?.id, openNewChamadoCookie]);
  const unidade = useWatch({ control, name: 'unidade' });
  const chamadosType = useWatch({ control, name: 'chamadosType' });
  const dependenceArray = [
    period,
    cookie?.companies?.id,
    debouncedSearchTerm,
    unidade,
    chamadosType,
    openNewChamadoCookie,
  ];
  useEffect(() => {
    if (cookie?.companies?.id) {
      fetchFilters();
      fetchOccurNumber(debouncedSearchTerm);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependenceArray);
  useEffect(() => {
    if (cookie?.companies?.id) {
      if (occurrenceNumber > 0) {
        fetchData(debouncedSearchTerm);
        setIsFirstMount(false);
        getItensPerPage();
      }
    }

    // eslint-disable-next-line
  }, [errors, itensPerPage, pageNumber, period, cookie?.companies?.id, occurrenceNumber]);

  const [fields, setFields] = useState([]);
  const [pendingOccurrences, setPendingOcurrences] = useState([]);
  const getItensPerPage = () => {
    setItensPerPage(getValues('pageItens'));
  };
  const pageCount1 = Math.ceil(occurrenceNumber / itensPerPage);
  const changePage = ({ selected }) => {
    setPageNumber(selected + 1);
  };
  const isDesktop = useMediaQuery({ minWidth: 1081 });
  const handleSearch = event => {
    const query = event.target.value;
    setSearchTerm(query);
  };
  const searchInputRef = useRef(null);
  const cleanFilters = () => {
    setValue('unidade', '');
    setValue('status', '');
    setValue('equipamento', '');
    setValue('ambiente', '');
    setSearchTerm('');
    fetchOccurNumber(debouncedSearchTerm);
    if (searchInputRef.current) {
      searchInputRef.current.value = '';
    }
  };
  const [activeTab, setActiveTab] = useState('historico');
  const loadMoreAreas = async () => {
    const nextPage = 1 + areaPage;
    try {
      const res = await ChamadoService.getAreas({
        empresa: cookie?.companies?.id,
        siteId: getValues('unidade'),
        PageSize: 50,
        PageIndex: nextPage,
        Search: areaSearch,
      });
      const sanatizedArea = res?.data?.map(({ gid, nome, ...rest }) => ({
        label: nome,
        value: gid,
        ...rest,
      }));
      setFilters(prev => ({ ...prev, ambiente: [...prev?.ambiente, ...sanatizedArea] }));
      setAreaPage(nextPage);
    } catch (err) {
      createGenericErrorToast(setToastList);
      console.error(err);
    }
  };
  const debounceAreaRef = useRef(null);

  const searchArea = term => {
    setAreaSearch(term);
    setAreaPage(1);

    if (debounceAreaRef.current) {
      clearTimeout(debounceAreaRef.current);
    }

    debounceAreaRef.current = setTimeout(async () => {
      try {
        const res = await ChamadoService.getAreas({
          empresa: cookie?.companies?.id,
          siteId: getValues('unidade'),
          PageSize: 50,
          PageIndex: 1,
          Search: term,
        });

        const sanitizedArea = res?.data?.map(({ gid, nome, ...rest }) => ({
          label: nome,
          value: gid,
          ...rest,
        }));

        setFilters(prev => ({
          ...prev,

          ambiente: sanitizedArea,
        }));
      } catch (err) {
        createGenericErrorToast(setToastList);
        console.error(err);
      }
    }, 400);
  };
  const loadMoreEquipamentos = async () => {
    const nextPage = 1 + equipamentoPage;
    try {
      const res = await ChamadoService.getEquipments({
        empresa: cookie?.companies?.id,
        siteId: getValues('unidade'),
        PageSize: 50,
        PageIndex: nextPage,
        Search: equipamentoSearch,
      });
      const sanatizedEquip = res?.data?.map(({ gid, nome, ...rest }) => ({
        label: nome,
        value: gid,
        ...rest,
      }));
      setFilters(prev => ({
        ...prev,
        equipamento: [...prev?.equipamento, ...sanatizedEquip],
      }));
      setEquipamentoPage(nextPage);
    } catch (err) {
      createGenericErrorToast(setToastList);
      console.error(err);
    }
  };
  const debounceEquipamentoRef = useRef(null);

  const searchEquipamento = term => {
    setEquipamentoSearch(term);
    setEquipamentoPage(1);
    if (debounceEquipamentoRef.current) {
      clearTimeout(debounceEquipamentoRef.current);
    }

    debounceEquipamentoRef.current = setTimeout(async () => {
      try {
        const res = await ChamadoService.getEquipments({
          empresa: cookie?.companies?.id,
          siteId: getValues('unidade'),
          PageSize: 50,
          PageIndex: 1,
          Search: term,
        });

        const sanitizedEquip = res?.data?.map(({ gid, nome, ...rest }) => ({
          label: nome,
          value: gid,
          ...rest,
        }));

        setFilters(prev => ({
          ...prev,

          equipamento: sanitizedEquip,
        }));
      } catch (err) {
        createGenericErrorToast(setToastList);
        console.error(err);
      }
    }, 400);
  };
  return (
    <Page>
      <CustomerPortalHeader setOpenMyProfile={setOpenMyProfile} openMyProfile={openMyProfile} />
      <Content>
        {openNewChamadoModal && (
          <NovoChamado
            updateTable={() => fetchData(debouncedSearchTerm)}
            setOpenNewChamadoModal={setOpenNewChamadoModal}
            values={getValues()}
          />
        )}
        {openMyProfile && <CustumerProfile />}
        {!openMyProfile && (
          <>
            <ContentHeader></ContentHeader>

            <TablecontainerWrapper>
              {isDesktop && (
                <>
                  <StyledContainerHeader>
                    <TableTitle isActive={activeTab === 'historico'} onClick={() => setActiveTab('historico')}>
                      Histórico de Chamados
                    </TableTitle>
                    <TableTitle isActive={activeTab === 'aprovacao'} onClick={() => setActiveTab('aprovacao')}>
                      Aguardando sua Aprovação {pendingOccurrences.length > 0 ? `(${pendingOccurrences.length})` : ''}
                    </TableTitle>
                    <OpenCallButton
                      onClick={() => {
                        setOpenNewChamadoModal(true);
                        Sentry.captureMessage('Novo Chamado', {
                          tags: { Empresa: cookie?.companies?.id },
                        });
                      }}
                    >
                      <PlusIcon />
                      ABRIR UM CHAMADO
                    </OpenCallButton>
                  </StyledContainerHeader>
                  <FieldRow marginBottom="1rem">
                    <StyledInnerGridColumn size={2} columnGap="1rem">
                      <StyledFormGroup label={'Data de Abertura'} isRequired width={'38%'} inputSize={'85%'}>
                        <Controller
                          render={props => (
                            <StyledDateRangePicker
                              {...props}
                              data-cy="opening-of-occurrence-date-picker"
                              size="small"
                              placeholder="Seleção obrigatória"
                              required={false}
                              notClean={true}
                              value={`${format(initialPeriod[0], 'yyyy-MM-dd')}/${format(
                                initialPeriod[1],
                                'yyyy-MM-dd',
                              )}`}
                            />
                          )}
                          name="period"
                          control={control}
                        />
                      </StyledFormGroup>
                      <SearchAndFilterContainer>
                        <StyledContainerSearchBar
                          placeholder={'Pesquisar Nº Chamado / Descrição'}
                          onChange={handleSearch}
                          ref={searchInputRef}
                        />
                        {filterIsOpen && (
                          <CleanFiltersButton onClick={cleanFilters}>
                            <CleanFilterIcon />
                            LIMPAR FILTROS
                          </CleanFiltersButton>
                        )}
                        <FiltersButton onClick={() => setFilterIsOpen(!filterIsOpen)}>
                          {filterIsOpen === true ? <CloseFilterIcon /> : <FilterIcon />}
                          FILTROS
                        </FiltersButton>

                        <ReloadButton onClick={() => fetchData(debouncedSearchTerm)}>
                          <ReloadIcon />
                          ATUALIZAR LISTA
                        </ReloadButton>
                      </SearchAndFilterContainer>
                    </StyledInnerGridColumn>
                    {filterIsOpen && (
                      <>
                        <StyledInnerGridColumn size={1}>
                          <StyledFormGroup label={'Unidade'} width={'25%'} inputSize={'100%'}>
                            <Controller
                              name="unidade"
                              control={control}
                              key={watch('unidade')}
                              //defaultValue={watch('unidade')}
                              render={props => (
                                <Select
                                  {...props}
                                  size="small"
                                  inputDifferent={true}
                                  placeholder="Seleção Opcional"
                                  options={filters?.unidade}
                                  value={watch('unidade')}
                                  // onInputChange={handleChange}
                                  onChange={value => {
                                    //handleChange(value);
                                    props.onChange(value);
                                    if (value === '') {
                                      setValue('equipamento', '');
                                      setValue('ambiente', '');
                                    }
                                    fetchOccurNumber(debouncedSearchTerm);
                                  }}
                                  ref={null}
                                />
                              )}
                            />
                          </StyledFormGroup>
                          <StyledFormGroup
                            label={'Ambiente'}
                            width={'25%'}
                            inputSize={'100%'}
                            disabled={!watch('unidade')}
                          >
                            <Controller
                              name="ambiente"
                              control={control}
                              //defaultValue={fields?.companie?.cidade}
                              render={props => (
                                <Select
                                  {...props}
                                  size="small"
                                  hasTooltip={true}
                                  tooltipText="Selecione uma Unidade para ver a lista de Ambientes."
                                  inputDifferent={true}
                                  placeholder="Seleção Opcional"
                                  options={filters?.ambiente}
                                  searchMode="remote"
                                  dataMode="infinite"
                                  onSearch={searchArea}
                                  onScrollEnd={loadMoreAreas}
                                  disabled={!watch('unidade')}
                                  // onInputChange={handleChange}
                                  onChange={value => {
                                    //handleChange(value);
                                    props.onChange(value);
                                    //fetchData();
                                    fetchOccurNumber(debouncedSearchTerm);
                                  }}
                                  ref={null}
                                />
                              )}
                            />
                          </StyledFormGroup>
                          <StyledFormGroup
                            label={'Equipamento'}
                            width={'25%'}
                            inputSize={'100%'}
                            disabled={!watch('unidade')}
                          >
                            <Controller
                              name="equipamento"
                              control={control}
                              //defaultValue={fields?.companie?.cidade}
                              render={props => (
                                <Select
                                  {...props}
                                  size="small"
                                  hasTooltip={true}
                                  tooltipText="Selecione uma Unidade para ver a lista de Equipamentos."
                                  inputDifferent={true}
                                  disabled={!watch('unidade')}
                                  searchMode="remote"
                                  dataMode="infinite"
                                  onSearch={searchEquipamento}
                                  onScrollEnd={loadMoreEquipamentos}
                                  placeholder="Seleção Opcional"
                                  options={filters?.equipamento}
                                  // onInputChange={handleChange}
                                  onChange={value => {
                                    //handleChange(value);
                                    props.onChange(value);
                                    //fetchData();
                                    fetchOccurNumber(debouncedSearchTerm);
                                  }}
                                  ref={null}
                                />
                              )}
                            />
                          </StyledFormGroup>
                          <StyledFormGroup label={'Status'} width={'25%'} inputSize={'100%'}>
                            <Controller
                              name="status"
                              control={control}
                              //defaultValue={fields?.companie?.cidade}
                              render={props => (
                                <Select
                                  {...props}
                                  size="small"
                                  inputDifferent={true}
                                  placeholder="Seleção Opcional"
                                  options={statusOptions}
                                  // onInputChange={handleChange}
                                  onChange={value => {
                                    //handleChange(value);
                                    props.onChange(value);
                                    fetchOccurNumber(debouncedSearchTerm);
                                    //fetchData();
                                  }}
                                  ref={null}
                                />
                              )}
                            />
                          </StyledFormGroup>
                        </StyledInnerGridColumn>
                      </>
                    )}
                    <StyledInnerGridColumn size={1}>
                      <RadioFormGroup label={'Exibir: '}>
                        <StyledFormRadio>
                          <Radio
                            disabled={cookie?.chamadosAccess?.chamado}
                            text="Todos os chamados"
                            type="radio"
                            id="todosChamados"
                            name="chamadosType"
                            value="todos"
                            ref={register()}
                          />
                          <Radio
                            text="Chamados que eu abri "
                            type="radio"
                            id="meusChamados"
                            name="chamadosType"
                            value="meus"
                            ref={register()}
                          />
                        </StyledFormRadio>
                      </RadioFormGroup>
                    </StyledInnerGridColumn>
                  </FieldRow>
                  {occurrenceNumber === 0 ? (
                    <NoOcurrenceScreen>
                      <NotFoundIcon />
                      <p>Nenhum chamado foi encontrado.</p>
                    </NoOcurrenceScreen>
                  ) : (
                    <>
                      <CustomerPortalTable
                        columns={columns}
                        data={activeTab === 'historico' ? fields : pendingOccurrences}
                        activeTab={activeTab}
                        loading={loading}
                        updateTable={() => fetchData(debouncedSearchTerm)}
                      />

                      <StyledContainerFooter>
                        <LeftContainerFooter>
                          <h3>Itens por página:</h3>
                          <FieldRow marginSides="16px">
                            <Controller
                              render={props => (
                                <Select
                                  {...props}
                                  size="small"
                                  hasSearchBar={false}
                                  options={pageOptions}
                                  setValue={setValue}
                                  defaultValue={isFirstMount ? props.defaultValue : 5}
                                  onChange={value => {
                                    props.onChange(value);
                                    setPageNumber(1);
                                    getItensPerPage();
                                  }}
                                  ref={null}
                                />
                              )}
                              name={'pageItens'}
                              control={control}
                              defaultValue={pageOptions[0].value}
                            />
                          </FieldRow>
                          {activeTab === 'historico' && <h4>Total de {occurrenceNumber} itens</h4>}
                        </LeftContainerFooter>
                        <RightContainerFooter>
                          <Paginate
                            previousLabel={
                              <svg
                                width="6"
                                height="10"
                                viewBox="0 0 6 10"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M5 1L1 5L5 9"
                                  stroke="#AAAAAA"
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            }
                            nextLabel={
                              <svg
                                width="6"
                                height="10"
                                viewBox="0 0 6 10"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M1 1L5 5L1 9"
                                  stroke="#AAAAAA"
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            }
                            pageCount={pageCount1}
                            onPageChange={changePage}
                            breakLabel={'...'}
                            marginPagesDisplayed={1}
                            pageRangeDisplayed={4}
                          />
                        </RightContainerFooter>
                      </StyledContainerFooter>
                    </>
                  )}
                </>
              )}
              {!isDesktop && (
                <>
                  <StyledContainerHeader>
                    <FadingWrapper>
                      <ScrollArea>
                        <TableTitle isActive={activeTab === 'historico'} onClick={() => setActiveTab('historico')}>
                          Histórico de Chamados
                        </TableTitle>

                        <TableTitle isActive={activeTab === 'aprovacao'} onClick={() => setActiveTab('aprovacao')}>
                          Aguardando sua Aprovação{' '}
                          {pendingOccurrences.length > 0 ? `(${pendingOccurrences.length})` : ''}
                        </TableTitle>
                      </ScrollArea>
                      <RightFade />
                    </FadingWrapper>
                    <OpenCallButton onClick={() => setOpenNewChamadoModal(true)}>
                      <PlusIcon />
                      ABRIR UM CHAMADO
                    </OpenCallButton>
                    <FiltersButton onClick={() => setFilterIsOpen(!filterIsOpen)}>
                      {filterIsOpen === true ? <CloseFilterIcon /> : <FilterIcon />}
                      FILTROS
                    </FiltersButton>
                  </StyledContainerHeader>
                  <FieldRow marginBottom="1rem">
                    <StyledInnerGridColumn size={2} columnGap="1rem">
                      {filterIsOpen && (
                        <MobileCleanFilterDiv>
                          <CleanFiltersButton onClick={cleanFilters}>
                            <CleanFilterIcon />
                            LIMPAR FILTROS
                          </CleanFiltersButton>
                        </MobileCleanFilterDiv>
                      )}
                      <StyledFormGroup label={'Data de Abertura'} isRequired width={'50%'} inputSize={'85%'}>
                        <Controller
                          render={props => (
                            <DateRangePicker
                              {...props}
                              data-cy="opening-of-occurrence-date-picker"
                              size="small"
                              notClean={true}
                              value={`${format(initialPeriod[0], 'yyyy-MM-dd')}/${format(
                                initialPeriod[1],
                                'yyyy-MM-dd',
                              )}`}
                              placeholder="Seleção obrigatória"
                              required={false}
                            />
                          )}
                          name="period"
                          control={control}
                          defaultValue={''}
                        />
                      </StyledFormGroup>
                    </StyledInnerGridColumn>
                    {filterIsOpen && (
                      <>
                        <StyledInnerGridColumn size={1}>
                          <StyledFormGroup label={'Unidade'} width={'283px'} inputSize={'100%'}>
                            <Controller
                              name="unidade"
                              control={control}
                              //defaultValue={fields?.companie?.cidade}
                              render={props => (
                                <Select
                                  {...props}
                                  size="small"
                                  inputDifferent={true}
                                  placeholder="Seleção Opcional"
                                  options={filters?.unidade}
                                  // onInputChange={handleChange}
                                  onChange={value => {
                                    //handleChange(value);
                                    props.onChange(value);
                                    fetchOccurNumber(debouncedSearchTerm);
                                  }}
                                  ref={null}
                                />
                              )}
                            />
                          </StyledFormGroup>
                          <StyledFormGroup label={'Ambiente'} width={'283px'} inputSize={'100%'}>
                            <Controller
                              name="ambiente"
                              control={control}
                              //defaultValue={fields?.companie?.cidade}
                              render={props => (
                                <Select
                                  {...props}
                                  size="small"
                                  inputDifferent={true}
                                  placeholder="Seleção Opcional"
                                  options={filters?.ambiente}
                                  searchMode="remote"
                                  dataMode="infinite"
                                  onSearch={searchArea}
                                  onScrollEnd={loadMoreAreas}
                                  // onInputChange={handleChange}
                                  onChange={value => {
                                    //handleChange(value);
                                    props.onChange(value);
                                    //fetchData();
                                    fetchOccurNumber(debouncedSearchTerm);
                                  }}
                                  ref={null}
                                />
                              )}
                            />
                          </StyledFormGroup>
                          <StyledFormGroup label={'Equipamento'} width={'283px'} inputSize={'100%'}>
                            <Controller
                              name="equipamento"
                              control={control}
                              //defaultValue={fields?.companie?.cidade}
                              render={props => (
                                <Select
                                  {...props}
                                  size="small"
                                  inputDifferent={true}
                                  placeholder="Seleção Opcional"
                                  options={filters?.equipamento}
                                  searchMode="remote"
                                  dataMode="infinite"
                                  onSearch={searchEquipamento}
                                  onScrollEnd={loadMoreEquipamentos}
                                  // onInputChange={handleChange}
                                  onChange={value => {
                                    //handleChange(value);
                                    props.onChange(value);
                                    //fetchData();
                                    fetchOccurNumber(debouncedSearchTerm);
                                  }}
                                  ref={null}
                                />
                              )}
                            />
                          </StyledFormGroup>
                          <StyledFormGroup label={'Status'} width={'200px'} inputSize={'100%'}>
                            <Controller
                              name="status"
                              control={control}
                              //defaultValue={fields?.companie?.cidade}
                              render={props => (
                                <Select
                                  {...props}
                                  size="small"
                                  inputDifferent={true}
                                  placeholder="Seleção Opcional"
                                  options={statusOptions}
                                  // onInputChange={handleChange}
                                  onChange={value => {
                                    //handleChange(value);
                                    props.onChange(value);
                                    fetchOccurNumber(debouncedSearchTerm);
                                    //fetchData();
                                  }}
                                  ref={null}
                                />
                              )}
                            />
                          </StyledFormGroup>
                        </StyledInnerGridColumn>
                      </>
                    )}
                    <StyledInnerGridColumn size={1}>
                      <RadioFormGroup label={'Exibir:'}>
                        <StyledFormRadio>
                          <Radio
                            disabled={cookie?.chamadosAccess?.chamado}
                            text="Todos os chamados"
                            type="radio"
                            id="todosChamados"
                            name="chamadosType"
                            value="todos"
                            ref={register()}
                          />
                          <Radio
                            text="Chamados que eu abri"
                            type="radio"
                            id="meusChamados"
                            name="chamadosType"
                            value="meus"
                            ref={register()}
                          />
                        </StyledFormRadio>
                      </RadioFormGroup>
                    </StyledInnerGridColumn>
                    <StyledInnerGridRow>
                      <StyledContainerSearchBar
                        placeholder={'Pesquisar'}
                        onChange={handleSearch}
                        ref={searchInputRef}
                      />

                      <ReloadButton onClick={() => fetchData(debouncedSearchTerm)}>
                        <ReloadIcon />
                        ATUALIZAR LISTA
                      </ReloadButton>
                    </StyledInnerGridRow>
                  </FieldRow>
                  {occurrenceNumber === 0 ? (
                    <NoOcurrenceScreen>
                      <NotFoundIcon />
                      <p>Nenhum chamado foi encontrado.</p>
                    </NoOcurrenceScreen>
                  ) : (
                    <>
                      <MobileCustomerPortalTable
                        columns={columns}
                        data={activeTab === 'historico' ? fields : pendingOccurrences}
                        loading={loading}
                        activeTab={activeTab}
                        updateTable={() => fetchData(debouncedSearchTerm)}
                      />

                      <StyledContainerFooter>
                        <LeftContainerFooter>
                          <h3>Itens por página:</h3>
                          <FieldRow marginSides="16px">
                            <Controller
                              render={props => (
                                <Select
                                  {...props}
                                  size="small"
                                  hasSearchBar={false}
                                  options={pageOptions}
                                  setValue={setValue}
                                  defaultValue={isFirstMount ? props.defaultValue : 5}
                                  onChange={value => {
                                    props.onChange(value);
                                    setPageNumber(1);
                                    getItensPerPage();
                                  }}
                                  ref={null}
                                />
                              )}
                              name={'pageItens'}
                              control={control}
                              defaultValue={pageOptions[0].value}
                            />
                          </FieldRow>
                          {/* <h4>Total de {fields.length} itens</h4> */}
                        </LeftContainerFooter>
                        <RightContainerFooter>
                          <Paginate
                            previousLabel={
                              <svg
                                width="6"
                                height="10"
                                viewBox="0 0 6 10"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M5 1L1 5L5 9"
                                  stroke="#AAAAAA"
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            }
                            nextLabel={
                              <svg
                                width="6"
                                height="10"
                                viewBox="0 0 6 10"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M1 1L5 5L1 9"
                                  stroke="#AAAAAA"
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            }
                            pageCount={pageCount1}
                            onPageChange={changePage}
                            breakLabel={'...'}
                            marginPagesDisplayed={1}
                            pageRangeDisplayed={4}
                          />
                        </RightContainerFooter>
                      </StyledContainerFooter>
                    </>
                  )}
                </>
              )}
            </TablecontainerWrapper>
          </>
        )}
        <FooterContainer>
          <LogoBlack />
          <p>Todos os direitos reservados.</p>
        </FooterContainer>
      </Content>
      <AtentionModal
        hasHeader
        title="Selecione outra unidade"
        icon={<WarningIcon />}
        size={{ width: isDesktop ? '448px' : '100%', height: '300px' }}
        success={true}
        open={invalidUnit}
        closeModal={closeWarningModal}
      >
        <p>Você não tem acesso a essa unidade. Por favor, selecione outra.</p>
        <Button theme="primary" onClick={closeWarningModal}>
          Entendi
        </Button>
      </AtentionModal>
      <Toast toastList={toastList} autoDelete dismissTime={5000} />
    </Page>
  );
};
